import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { initSessionFromCookie } from "../actions/session";
import { connect } from 'react-redux'
import { hasCapability } from "../lib/capabilities";
import NoAccess from "../components/NoAccess";


const mapStateToProps = state => {
    return { session: state.session }
}

function mapDispatchToProps(dispatch) {
    return {
        initSessionFromCookie: () => dispatch(initSessionFromCookie())
    }
}

class PrivateRoute extends Component {
    constructor(props) {
        super(props)
        this.state = { initSessionFromCookie: true }
        this.props.initSessionFromCookie()
            .then(() => { this.setState({ initSessionFromCookie: false }) })
    }

    render() {
        if (this.state.initSessionFromCookie) {
            return <div />
        }
        const { component: Component, requiredCapability, ...rest } = this.props;
        if (!this.props.session.isLoggedIn) {
            const redirectPath = window.location.pathname
            localStorage.setItem('redirectPath', redirectPath);
        }
        return <Route {...rest} render={props => {
            if (!this.props.session.isLoggedIn) {
                return <Redirect to='/login' />
            }
            // Logged in but lacking the capability: show NoAccess (consistent
            // with Orders) rather than redirect. This is UX gating only — the
            // backend independently enforces the same capability.
            if (requiredCapability && !hasCapability(this.props.session, requiredCapability)) {
                return <NoAccess />
            }
            return <Component {...props} />
        }} />
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)